import React from 'react';
import init from '../AccessControl/Check';

const PermissionList = () => {
    const pageName = "Permission View";
    init(pageName);

    return (
        <div>
            Permission List
        </div>
    );
};

export default PermissionList;